import {BaseDTO} from '../../../common/models/BaseDTO';
import {DiagnosisDTO} from '../../../ent/models/DiagnosisDTO';

export class CaseHospitalDiagnosisLinkDTO extends BaseDTO {
  diagnosis: DiagnosisDTO;
  startDate: Date;
  endDate: Date;
  icdTier: string;
}